module.exports = __webpack_public_path__ + "static/media/tab-house-chocolatey.1857111e.png";